module.exports = __webpack_public_path__ + "static/media/therapist.b6d0b3d0.jpg";